module.exports = __webpack_public_path__ + "static/media/pickle.b0eb6162.png";